module.exports = __webpack_public_path__ + "img/option3.184053f6.svg";